import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state to trigger fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log the error to an error reporting service
    console.log('Error logged:', error, info);
    // For production: Send to a service like Sentry, etc.
    // reportErrorToService(error, info);
  }

  DefaultErrorComponent = () => {
    return (
        <Box className="w-full h-full flex items-center justify-center">
            <Typography variant='h5'>Something went wrong. Please try again.</Typography>
        </Box>
    )
  }

  render() {
    if (this.state.hasError) {
      // Fallback to a custom UI if provided, otherwise show a default fallback
      if(this.props.fallback)
        return this.props.fallback()
      return this.DefaultErrorComponent();
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.element,
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
